// extracted by mini-css-extract-plugin
export default {"up":"UpButton_up__g74tM","show":"UpButton_show__2rkR0"};